
import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';

export default function FloatingWhatsApp() {
  return (
    <motion.a
      href="https://wa.me/27723330922?text=Hi%20Hublu%20team"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 left-5 md:bottom-6 md:left-6 z-40 w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-2xl transition-all duration-200 group"
      whileHover={{ scale: 1.1 }}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      aria-label="Contact us on WhatsApp"
      title="Contact us on WhatsApp"
    >
      <motion.div
        animate={{ scale: [1, 1.1, 1] }}
        transition={{ repeat: Infinity, duration: 2, repeatType: "reverse", ease: "easeInOut" }}
      >
        <MessageCircle className="w-7 h-7" />
      </motion.div>
      {/* Visual Tooltip for larger screens */}
      <span className="absolute left-16 bg-[hsl(var(--charcoal))] text-white text-xs font-medium px-3 py-1.5 rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all whitespace-nowrap hidden md:block">
        Contact us on WhatsApp
      </span>
    </motion.a>
  );
}
